import { Component, computed, ElementRef, inject } from '@angular/core';
import { AppMenu } from '../menu/app.menu';
import { AuthService } from '@features/auth/services/auth.service';
import { rxResource } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ServerResponse } from 'src/app/core/interfaces/server.interface';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu],
    templateUrl: './app.sidebar.html'
})
export class AppSidebar {


    authService = inject(AuthService);


    authResource = rxResource({
        request: () => ({}),
        loader: () => {
            return this.authService.getModules().pipe(
                tap((response: ServerResponse) => {
                    // Accedemos a response.data.modules según tu JSON
                    const modules = response.data.modules || [];

                    const allPermissions = modules.flatMap((category: any) =>
                        category.items?.flatMap((item: any) =>
                            item.permissions?.map((p: any) =>
                                `${item.id}.${p.name}`
                            ) || []
                        ) || []
                    );

                    this.authService.setUserPermissions(allPermissions);
                })
            );
        }
    });

    menuItems = computed<MenuItem[]>(() => {
        const response = this.authResource.value();

        // 1. Definimos el ítem estático del Dashboard
        const dashboardItem: MenuItem = {
            items: [
                {
                    label: 'Dashboard',
                    icon: 'pi pi-fw pi-chart-bar',
                    routerLink: ['/']
                }
            ]
        };

        // 2. Si aún no hay respuesta de la API, solo mostramos el Dashboard
        if (!response?.data?.modules) {
            return [dashboardItem];
        }

        // 3. Mapeamos los módulos de la API
        const apiMappedItems = response.data.modules.map((category: any) => ({
            items: [
                {
                    label: category.label,
                    icon: category.icon,
                    items: category.items?.map((item: any) => ({
                        label: item.name,
                        routerLink: [item.route]
                    }))
                }
            ]
        }));

        // 4. Unimos ambos: Dashboard al principio y luego lo que trajo la base de datos
        return [dashboardItem, ...apiMappedItems];
    });

    constructor(public el: ElementRef) { }
}
